import tw, { styled } from 'twin.macro';
import Icon from '@/components/Icon/IconAsset';

export const StyledContainer = styled.div`
  ${tw`lg:col-span-3`}
  ${tw`p-2`}
  ${tw`bg-neutrals-n1`}
  ${tw`rounded-xl`}
`;

export const StyledIcon = styled(Icon)`
  ${tw`text-primary-p1`}
  ${tw`w-[26px] h-[26px]`}
  ${tw`mb-2`}
`;

export const StyledTitle = styled.h2`
  ${tw`font-poppins font-semi-bold`};
  ${tw`text-mobile-heading-m lg:text-heading-m text-primary-p1`}
  ${tw`mb-2 md:mb-1`}
`;

export const StyledDescription = styled.p`
  ${tw`font-inter font-medium lg:font-regular`};
  ${tw`text-body-m lg:text-body-l text-primary-p1`}
`;
